import { loan_application_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';
import { loan_application } from '@axo/shared/data-access/types';
import { useMutation, useQueryClient } from 'react-query';
import { applicationKeys } from '../../cache-keys/applicationKeys';

export function usePatchApplicationExpense() {
  const client = useQueryClient();
  const api = useAPI();

  return useMutation({
    mutationFn: async ({
      applicationID,
      expenseID,
      data,
    }: {
      applicationID: string;
      expenseID: string;
      data: loan_application.CreateExpense;
    }) =>
      await loan_application_api.patchExpense(api)(
        applicationID,
        expenseID,
        data,
      ),

    onSettled: (_data, _error, variables) => {
      client.removeQueries(applicationKeys.expenses(variables.applicationID));
      client.removeQueries(
        applicationKeys.root({ applicationID: variables.applicationID }),
      );
    },
  });
}
